import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'underscore';
import { DataService } from 'src/app/shared/services/data.service';
import { TreeSelect } from 'primeng/treeselect';
import { TranslateService } from '@devinforius/i-essentials';
import { ServicesService } from 'src/app/shared/services/services.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ActionsService } from 'src/app/shared/services/actions.service';
import { MailsTakeChargeService } from 'src/app/shared/services/mails-take-charge.service';
import { ConfigForTakeOverMailsDto } from 'src/app/shared/interfaces/config';
import { Mail } from 'src/app/shared/models/mails/mail';
import { ServicesPTreeSelect } from 'src/app/shared/models/iCourrier/service';
import { manageServicesSetAsTreeSelect, manageServicesToBeMerged } from 'src/app/shared/utils/manage-services-for-tree-select.utils';
@Component({
  selector: 'app-prendre-en-charge-modal',
  templateUrl: './prendre-en-charge-modal.component.html',
  styleUrls: ['./prendre-en-charge-modal.component.scss'],
})
export class PrendreEnChargeModalComponent implements OnInit {
  @ViewChild('treeSelectMultiple') treeSelectMultiple: TreeSelect;
  @ViewChild('treeSelectDemandeur') treeSelectDemandeur: TreeSelect;
  @ViewChild('treeSelectPrincipal') treeSelectPrincipal: TreeSelect;
  public form = new UntypedFormGroup({
    action: new UntypedFormControl(null),
    commentaires: new UntypedFormControl(null),
    dateEcheance: new UntypedFormControl(null),
    priseEnChargeExclusive: new UntypedFormControl(null),
    serviceDemandeId: new UntypedFormControl(null),
    servicePrincipalId: new UntypedFormControl(null),
    services: new UntypedFormControl([]),
  });
  public actionsLV: { label: string; value: string }[] = [];
  public right: ConfigForTakeOverMailsDto = null;
  public enable: boolean = false;
  public disabled: boolean = false;
  public isRequired = false;
  public courrier: Mail;
  public serviceParent: ServicesPTreeSelect[] = [];
  public serviceParentMultiCheck: ServicesPTreeSelect[] = [];
  public servicesFusionned: {
    label: string;
    value: number;
    parentId: number;
    id: number;
    name: string;
    key: string;
    selectable: boolean;
    children: [];
  }[] = [];
  public selectedOption = null;
  public selectedOption2 = null;
  public translationPlaceholderPTree: string = '';
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dataService: DataService,
    public toastr: ToastrService,
    public translater: TranslateService,
    private servicesService: ServicesService,
    private configService: ConfigService,
    private actionsService: ActionsService,
    private mailsTakeChargeService: MailsTakeChargeService
  ) {}

  ngOnInit(): void {
    this.translationPlaceholderPTree = this.translater.translate('pleaseSelectAService');

    if (this.config?.data) {
      this.courrier = this.config.data.courrier;
    }
    this.getRight();
    this.getAllActionsTypes();
    this.getServices();
  }

  getRight(): void {
    this.configService.fetchConfig().subscribe({
      next: (res) => {
        this.right = res.priseEnChargeCourriers;
        if (this.right?.accesPriseEnChargeModeSimplifie === false) {
          this.form.controls.serviceDemandeId.setValidators([Validators.required]);
          this.form.controls.servicePrincipalId.setValidators([Validators.required]);
          this.isRequired = true;
        }
        this.form.patchValue({
          priseEnChargeExclusive: this.right.ficheCourrierObligationPriseEnChargeExclusive,
          dateEcheance: this.right.ficheCourrierDateLimitePriseEnChargeCachee
            ? moment('31/12/2099', 'DD/MM/YYYY').toDate()
            : moment().add('1', 'day').toDate(),
        });
        if (this.right.ficheCourrierObligationPriseEnChargeExclusive) {
          this.disabled = true;
        }
      },
    });
  }

  getAllActionsTypes(): void {
    this.actionsService.getAllActionsTypes().subscribe({
      next: (res) => {
        if (res) {
          res.forEach((item) => {
            this.actionsLV.push({ label: item.description, value: item.description });
          });
        }
      },
    });
  }

  getServices(): void {
    this.servicesService.fetchMappedServicesToPrimeNGDropdowns().subscribe({
      next: (response) => {
        const datasForService = manageServicesSetAsTreeSelect(response, this.translater);

        this.serviceParent = datasForService.servicesForSingleCheck;
        this.serviceParentMultiCheck = datasForService.servicesForMultiCheck;
        this.servicesFusionned = manageServicesToBeMerged(response);

        this.form.patchValue({
          serviceDemandeId: this.config.data.courrier.serviceProprietaireId,
        });
      },
    });
  }

  submit(): void {
    if (this.form.valid) {
      if (this.form.value.dateEcheance) {
        this.form.value.dateEcheance = moment(this.form.value.dateEcheance).format('YYYY-MM-DD');
      }

      this.mailsTakeChargeService.markAsTakeInCharge(this.courrier.id, this.form.value).subscribe({
        next: () => {
          this.toastr.success('Le courrier a bien été marqué comme à prendre en charge');
          this.ref.close(true);
          this.dataService.setRefreshList(true);
        },
      });
    } else {
      this.toastr.error('Les champs requis ne sont pas complétés');
    }
  }

  select(event, type): void {
    if (event.node && event.node.value) {
      if (type === 'serviceDemandeur') {
        if (this.selectedOption?.value !== event.node.value) {
          this.selectedOption = _.first(this.servicesFusionned.filter((x) => x.value === event.node.value));
          this.form.patchValue({ serviceDemandeId: event.node.value });
        } else {
          this.selectedOption = null;
          this.treeSelectDemandeur.value = [{ label: this.translationPlaceholderPTree }];
          this.form.patchValue({ serviceDemandeId: null });
        }
      } else if (type === 'servicePrincipal') {
        if (this.selectedOption2?.value !== event.node.value) {
          this.selectedOption2 = _.first(this.servicesFusionned.filter((x) => x.value === event.node.value));
          this.form.patchValue({ servicePrincipalId: event.node.value });
        } else {
          this.selectedOption2 = null;
          this.treeSelectPrincipal.value = [{ label: this.translationPlaceholderPTree }];
          this.form.patchValue({ servicePrincipalId: null });
        }
      }
    }
  }

  selectMultiple(): void {
    if (this.treeSelectMultiple.value.find((x) => x.key === 'inforiusCheckAllForServices')) {
      this.treeSelectMultiple.value = this.treeSelectMultiple.options;
      this.setPlaceholderServiceTreeSelect();
    } else {
      if (this.treeSelectMultiple.value.length === this.servicesFusionned.length) {
        this.treeSelectMultiple.value = this.treeSelectMultiple.value.concat({
          label: '',
          name: '',
          key: 'inforiusCheckAllForServices',
          value: 'inforiusCheckAllForServices',
          selectable: true,
          children: [],
        });
      }
      this.setPlaceholderServiceTreeSelect();
    }
    this.form.patchValue({ services: this.treeSelectMultiple.value.filter((x) => x.key !== 'inforiusCheckAllForServices').map((x) => x.value) });
  }

  unselectMultiple(event): void {
    if (event.node.key === 'inforiusCheckAllForServices') {
      this.treeSelectMultiple.value = [];
      this.setPlaceholderServiceTreeSelect();
      this.form.patchValue({ services: [] });
    } else {
      const indexCheckAll = this.treeSelectMultiple.value.map((x) => x.key).indexOf('inforiusCheckAllForServices');
      if (indexCheckAll > -1) {
        this.treeSelectMultiple.value.splice(indexCheckAll, 1);
      }
      this.setPlaceholderServiceTreeSelect();
      this.form.patchValue({ services: this.treeSelectMultiple.value.filter((x) => x.key !== 'inforiusCheckAllForServices').map((x) => x.value) });
    }
  }

  setPlaceholderServiceTreeSelect(): void {
    let amountOfSelectedServices = '';
    if (this.treeSelectMultiple.value.length === 0) {
      amountOfSelectedServices = this.translationPlaceholderPTree;
    } else if (this.treeSelectMultiple.value.length === 1) {
      amountOfSelectedServices = this.treeSelectMultiple.value[0].label;
    } else {
      const totalOfSelectedServices = this.treeSelectMultiple.value.filter((x) => x.key !== 'inforiusCheckAllForServices').length;
      if (totalOfSelectedServices === this.servicesFusionned.length) {
        amountOfSelectedServices = this.translater.translate('allServicesChecked', {
          value: totalOfSelectedServices,
        });
      } else {
        amountOfSelectedServices = this.translater.translate('xServicesChecked', {
          value: totalOfSelectedServices,
        });
      }
    }
    const labelTreeHtml = document.querySelectorAll('.pTreeMultiselect .p-treeselect-label');
    labelTreeHtml[0].innerHTML = amountOfSelectedServices;
  }
}
